import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgZapIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 90 90",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("radialGradient", {
			id: "zap-icon-gradient",
			cx: 47.65,
			cy: 47.68,
			r: 41.32,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				stopColor: "#4386ff"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#00549b"
			})]
		}) }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 47.65,
			cy: 47.68,
			r: 41.32,
			fill: "url(#zap-icon-gradient)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.47,18.31L37.27,4.16c.24-.1.52-.02.67.2l17.74,25.22c.23.32.08.79-.29.91l-4.75,1.54c-.38.12-.52.61-.27.93l14.01,17.64c.27.34.1.84-.3.94l-6.07,1.49c-.41.1-.57.61-.31.94l20.62,26.13c.39.5-.16,1.2-.71.89l-46.41-26.79c-.42-.24-.38-.88.07-1.06l5.59-2.21c.42-.17.49-.76.12-1.03l-18.84-13.6c-.37-.26-.31-.84.1-1.02l4.3-1.89c.41-.18.47-.76.1-1.02L4.36,19.33c-.37-.26-.31-.85.1-1.03Z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.48,4.12c.18,0,.35.09.45.24l17.74,25.22c.23.32.08.79-.29.91l-4.75,1.54c-.38.12-.52.61-.27.93l14.01,17.64c.27.34.1.84-.3.94l-6.07,1.49c-.41.1-.57.61-.31.94l20.62,26.13c.33.41,0,.96-.43.96-.09,0-.18-.02-.28-.08l-46.41-26.79c-.42-.24-.38-.88.07-1.06l5.59-2.21c.42-.17.49-.76.12-1.03l-18.84-13.6c-.37-.26-.31-.84.1-1.02l4.3-1.89c.41-.18.47-.76.1-1.02L4.36,19.33c-.37-.26-.31-.85.1-1.03L37.27,4.16c.07-.03.14-.04.22-.04M37.48,1c-.5,0-.99.1-1.45.3L3.23,15.44c-1.22.53-2.07,1.68-2.21,3.01-.14,1.33.45,2.64,1.53,3.42l14.66,10.44-.22.1c-1.21.53-2.05,1.68-2.19,3-.14,1.32.44,2.63,1.52,3.41l15.1,10.9-1.3.51c-1.33.53-2.22,1.74-2.32,3.18-.11,1.44.6,2.77,1.84,3.49l46.41,26.79c.56.32,1.2.5,1.84.5,1.39,0,2.69-.82,3.31-2.09.63-1.29.46-2.79-.43-3.92l-18.19-23.06,2.25-.55c1.22-.3,2.2-1.2,2.61-2.4.41-1.21.19-2.52-.61-3.52l-11.75-14.79,1.27-.41c1.11-.36,1.99-1.24,2.36-2.35.37-1.12.19-2.36-.48-3.32L40.49,2.56c-.69-.98-1.81-1.56-3.01-1.56h0Z",
			fill: "#000"
		})
	]
});
export default SvgZapIcon;
